/**
 * courses页面配置
 */
export default {
  /**
   * 新业务系统通用文案配置
   */
  gradeTitle: 'Year Group',
  termTitle: 'Term Time',
  lessonUnit: 'session',
  perLesson: '/lesson',
  lessonUnitTxt: '{0} session{1}',
  leftTxt: 'left',
  lessonLeft: '{1} session{2} {0}',
  lessonStarted: '{0} session{1} started',
  courseEnded: 'Course ended',
  suitableFor: 'Suitable for',
  from: 'From',
  noAddress: 'No address',
  classStore: '1 Space | {store} Spaces',
  // -------------------
  tutorText: 'Tutor',
  btnCoursesText: 'ENROL',
  procedureTitle: '3 Steps to Start Your Learning',
  step: 'Step {index}',
  FAQsTips: 'If you have any questions, please do take a look at our',
  procedureStep: [
    {
      cls: 'desktop-outline',
      themeColor: '#ccc',
      title: 'Course Registration',
      des:
      'Click "Enrol" to begin the course registration process.',
    },
    {
      cls: 'access-course-details',
      themeColor: '#ccc',
      title: 'Download The App',
      des: '<a href="/download" style="text-decoration: underline;color: #ffaa0a" class="stress">Download</a> \'Think Academy Student\' to your device so that your child can attend class, complete homework, and more!',
    },
    {
      cls: 'attend-the-class',
      themeColor: '#ccc',
      title: 'Time For Class!',
      des:
    'Open the app and tap "Live" to get started. Your child can enter our virtual classroom up to 10 minutes before the scheduled start time.',
    },
  ],
  bannerList: [
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/pc/courses/0-free-trial-banner-web.jpg',
      url: '',
      target: '',
    },
    // {
    //   src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/pc/courses/1_half_maths_courses_web.jpg',
    //   url: '',
    //   target: '',
    // },
    // {
    //   src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/pc/courses/course-page-banner-1-v5-new.jpg',
    //   url: '',
    //   target: '',
    // },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/pc/courses/02-summer-holiday-web.jpg',
      url: '',
      target: '',
    },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/pc/courses/03-autumn-courses-web.jpg',
      url: '',
      target: '',
    },

    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/pc/courses/04-math-tutor-web.jpg',
      url: '',
      target: '',
    },

    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/pc/courses/course-page-banner-2-v4.jpg',
      url: '',
      target: '',
    },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/pc/courses/course-page-banner-3-v6.jpg',
      url: '',
      target: '',
    },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/pc/courses/course-page-banner-4-v3.jpg',
      url: '',
      target: '',
    },
  ],
  // 课程介绍，招生简章
  // 年级 => 招生简章图片地址
  courseInformation: {
    0: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/common/course-information/202008/Y1.jpg',
    1: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/common/course-information/202008/Y2.jpg',
    2: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/common/course-information/202008/Y3.jpg',
    3: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/common/course-information/202008/Y4.jpg',
    4: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/common/course-information/202008/Y5.jpg',
    5: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/uk/common/course-information/202008/Y6.jpg',
  },
  inclusive: 'VAT',

  // 商城首页课程卡片文案配置
  courseCard: {
    levelDegreeMore: 'Different levels available',
    learnMore: 'Learn more',
    lowPricePrefix: 'From',
    lowPriceTailfix: '',
  },
  filter: {
    day: 'Day',
    time: 'Time',
    level: 'Level',
    grade: 'Grade',
  },
  fillIinformation: {
    title: 'If there is no class that meets your requirments, please fill in your information:',
    form: {
      group: 'Child’s Year Group',
      day: 'Day',
      time: 'Time',
      email: 'Your email',
      name: 'Your name',
      agree: 'Sign up for our mailing list to receive the latest news, promotions and updates!',
      submit: 'Submit',
    },
  },
}
